// extracted by mini-css-extract-plugin
export default {"dragPreventorDragging":"dragPreventorDragging--TNG71","dragPreviewItem":"dragPreviewItem--pslHh","horizontalItem":"horizontalItem--D8xoj","listDropSpacer":"listDropSpacer--ldFf5"};